import { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const useAgentSelectionCheck = () => {
  const { user } = useAuth();
  const [isRequired, setIsRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectionData, setSelectionData] = useState(null);

  useEffect(() => {
    const checkAgentSelection = async () => {
      if (!user) {
        setIsRequired(false);
        return;
      }

      try {
        setLoading(true);
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
        const response = await fetch(`${backendUrl}/api/subscription/agent-selection-required`, {
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          setIsRequired(data.required);
          setSelectionData(data);
        }
      } catch (error) {
        console.error('Error checking agent selection requirement:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAgentSelection();
  }, [user]);

  return { isRequired, loading, selectionData };
};

export default useAgentSelectionCheck;